import { ValueType } from '@nibras/core/common';
import { IdcValue } from './common.interfaces';
import { dcDataStoreItem } from './datastore-item.model';
import { IFormatting } from './dcattribute.model';
import { GenericValue } from './generic-value.model';

export interface IdcNFValueValue {
  ActualType: number;
}

export class dcValue<T extends GenericValue = any> //TODO: any needs to be removed.
  implements IdcValue, IdcNFValueValue, dcDataStoreItem, IFormatting
{
  ValueTypeID: ValueType;
  ValueInt?: number;
  ValueDouble?: number;
  ValueString?: string;
  ValueBoolean?: boolean;
  ValueGuid?: string;
  ValueTime?: Date;
  TimeStamp?: Date;
  IsGood: boolean;
  ActualType: number;
  Key: string;
  Value: T;
  MessageString: string;
  AdditionalInfo?: string;
  displayValue: any;
  style: ValueStyle;
  isConditionalFormattingApplied = false;
}

export class ValueStyle {
  backgroundColor: string;
  color: string;
  border: string;
  textAlign: string;
  _toolTip: string;
  isAnalysisField: boolean;
  additionalInfo: string;
  isGoodValue: boolean;
  showFormulaSymbol: boolean;
}

export type ValueFormat = string;

export const ValueFormatConstants = { ONLY_DATE: 'Date', DATE_AND_TIME: 'DateTime' };
